import { useQueryClient } from "@tanstack/react-query";
import api from "apis";
import { useSetRecoilState } from "recoil";
import { isFormReselectedState } from "store/document/documentCommon";

const useReselectDoc = () => {
  const queryClient = useQueryClient();

  const setIsFormReselect = useSetRecoilState(isFormReselectedState);

  /**
   * @description 재선택 버튼 클릭 이벤트 핸들러
   */
  const onClickReselect = ({
    uuid,
    callback,
  }: {
    uuid?: string;
    callback?: () => void;
  }) => {
    setIsFormReselect(true);

    if (uuid) {
      queryClient.invalidateQueries({
        queryKey: api.document.getTempDocumentDetailKey(uuid),
      });
    }

    if (callback) callback();
  };

  return {
    onClickReselect,
  };
};

export default useReselectDoc;
